export default {"src":"/_next/static/media/0xfa7f8980b0f1e64a2062791cc3b0871572f1f7f0.f2b8cf86.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};